import { Navigate, useParams } from "react-router-dom";
import { routes } from "@/routes/routes";
import type { BankCardResultState } from "../../types/bankCard";

// The card partner's return address (added or rejected alike): back to the
// screen that asked for the card, which tells the result in a popup.
export function AddBankCardResultPage() {
  const { resultType } = useParams();
  const state: BankCardResultState = { bankCardResult: resultType };

  return (
    <Navigate
      to={routes.application.installmentConfirmation}
      state={state}
      replace
    />
  );
}
